
// 生成月份的字符串列表
export function genMonthList(nMonth) {
  let now = new Date()
  const monthList = []
  for (let i = 0; i < nMonth; i++) {
    monthList.push(String(now.getFullYear()).substring(2) + '-' + String(now.getMonth() + 1).padStart(2,'0'))
    if (now.getMonth() - i < 0) {
      now.setFullYear(now.getFullYear() - 1)
      now.setMonth(11);
    } else {
      now.setMonth(now.getMonth() - 1)
    }
  }
  return monthList.reverse()
}

export function genDayList(nDay) {
  let now = new Date()
  const dayList = []
  for (let i = 0; i < nDay; i++) {
    dayList.push(String(now.getMonth() + 1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0'))
    now.setDate(now.getDate() - 1)
  }
  return dayList.reverse()
}

export function genHourList(nHour) {
  let now = new Date()
  const hourList = []
  for (let i = 0; i < nHour; i++) {
    hourList.push(String(now.getHours()).padStart(2,'0') + ":00")
    now.setHours(now.getHours() - 1)
  }
  return hourList.reverse()
}

export function genRandArrayWithSumOfOne(length) {
  if (length <= 0) return [];

  // Step 1: Generate random numbers
  let randomNumbers = Array.from({ length }, () => Math.random());

  // Step 2: Normalize the numbers so that their sum is 1
  let sum = randomNumbers.reduce((acc, val) => acc + val, 0);
  let normalizedNumbers = randomNumbers.map(x => x / sum);

  // Due to floating point precision issues, the sum might not be exactly 1.
  // We can adjust the last element to make sure the sum is exactly 1.
  let finalSum = normalizedNumbers.reduce((acc, val) => acc + val, 0);
  if (finalSum !== 1) {
    let difference = 1 - finalSum;
    normalizedNumbers[normalizedNumbers.length - 1] += difference;
  }

  return normalizedNumbers;
}
